<template>
  <div ref="Motion">
    <Animation :path="absoluteURL(module.file.url)" v-on:animCreated="handleAnimation"/>
  </div>
</template>

<script>
  import Animation from '@/components/elements/Animation.vue'
  import ScrollMagic from 'scrollmagic'
  import axios from 'axios';
  import ApiService from '@/services/api/ApiService.js';

  export default {
    name: 'animation',
    props: ['module'],
    components: {
      Animation,
    },
    data() {
      return {
        path: '',
        loading: true,
        animationSpeed: 1,
        controller: new ScrollMagic.Controller(),
      }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      animations(anim) {
        const {Motion} = this.$refs
        const scene = new ScrollMagic.Scene({
          triggerElement: Motion,
          triggerHook: 0.5,
          offset: 0
        }).on('enter', function (event) {
          anim.play();
        }).on('leave', function (event) {

        }).addTo(this.controller);
      },

      handleAnimation: function (anim) {
        this.anim = anim;
        this.animations(this.anim);
      },

      stop: function () {
        this.anim.stop();
      },

      play: function () {
        this.anim.play();
      },

      pause: function () {
        this.anim.pause();
      },

      onSpeedChange: function () {
        this.anim.setSpeed(this.animationSpeed);
      },
      absoluteURL(relativeURL) {
        return process.env.VUE_APP_HOST_URL + relativeURL;
      }
    }
  }
</script>
